import initialState from './initialState';
import { types } from '../actions/themeActions';

export default function themeReducer(state = initialState.theme, action) {
  switch (action.type) {
    case types.CHANGE_THEME:
    {
      return action.theme;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/themeReducer.js